import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { MusicIcon } from '@/atoms/Icons/MusicIcon'
import { ParagraphSM, TitleMD } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTicketsContext } from './TicketsContext'

interface SingAlongModalProps {
  handleShowtimeClick: () => void
  setShowSingAlongModal: (showSingAlongModal: boolean) => void
  showSingAlongModal: boolean
}

export const SingAlongModal = ({
  handleShowtimeClick,
  setShowSingAlongModal,
  showSingAlongModal,
}: SingAlongModalProps) => {
  const { t } = useTranslate('tickets')
  const { theatricalRelease } = useTicketsContext()

  return (
    <Modal isOpen={showSingAlongModal} onClose={() => setShowSingAlongModal(false)} panelClasses="!max-w-[361px]">
      <div className="absolute right-4 top-4">
        <Button
          variant="plain"
          className="rounded-full bg-core-gray-100 p-2"
          onClick={() => setShowSingAlongModal(false)}
        >
          <CloseIcon size={16} color="black" />
        </Button>
      </div>
      <div className="flex flex-col items-center gap-6">
        <div className="rounded-full border-2 border-core-warning-200/30 bg-core-warning-50 p-4">
          <MusicIcon color="warm-03" size={28} />
        </div>
        <div className="flex flex-col gap-2 text-center">
          <TitleMD weight="bold">{t('singAlongShowtime', 'Sing-Along Showtime')}</TitleMD>
          <ParagraphSM color="core-gray-700">
            {t(
              'singAlongShowtimeDescriptionWithTitle',
              'This special showtime includes on-screen lyrics during the musical moments in {{title}} so you can sing along with the cast.',
              {
                title: theatricalRelease.title,
              },
            )}
          </ParagraphSM>
        </div>
        <Button
          variant="black"
          size="sm"
          onClick={() => {
            handleShowtimeClick()
            setShowSingAlongModal(false)
          }}
        >
          {t('continue', 'Continue')}
        </Button>
      </div>
    </Modal>
  )
}
